export const withParagraph = ['pussnboots-deposit-freespin', 'pussnboots-15-freespin'];

export const withAuxBackground = ['ocean-15-freespin'];

export const withBubbles = ['ocean-15-freespin'];

export const withFreespinLogo = ['ocean-15-freespin', 'pussnboots-deposit-freespin', 'pussnboots-15-freespin'];
